import { useTranslation } from 'react-i18next';

import { DotRadio } from '../questions/dotRadio/DotRadio';
import { GadHeaderRow } from '../questions/dotRadio/GadHeaderRow';
import { AssessmentPageItem } from '../types/AssessmentPageItem';

export function MentalHealth3({
  assessmentValues,
  questionid,
  questionHeading,
  questionText,
  onSetValue,
}: AssessmentPageItem) {
  const { t } = useTranslation();
  const headerText = [
    { key: 0, value: t('radioOption.not_at_all') },
    { key: 1, value: t('radioOption.several_days') },
    { key: 2, value: t('radioOption.more_than_half_the_days') },
    { key: 3, value: t('radioOption.nearly_every_day') },
  ];
  const radioOptions = [
    t('radioOption.not_at_all'),
    t('radioOption.several_days'),
    t('radioOption.more_than_half_the_days'),
    t('radioOption.nearly_every_day'),
  ];

  return (
    <div className="question_container" id={questionid}>
      <h1>{questionHeading}</h1>
      <p>{questionText}</p>

      <fieldset className="question_block_wide gad" data-input-type="mental_health_anxiety">
        <legend className="assessment_question_title" id="over_last_2_weeks_3">
          {t('A090')}
        </legend>
        <div className="answer_block">
          <GadHeaderRow headerText={headerText} />
          <DotRadio
            questionid="nervous"
            range="4"
            width=""
            questionTitle={t('assessment.question.nervous')}
            type="gad"
            onSetValue={onSetValue}
            assessmentValues={assessmentValues}
            radioOptions={radioOptions}
            outerId="over_last_2_weeks_3"
          />
          <DotRadio
            questionid="control_worrying"
            range="4"
            width=""
            questionTitle={t('assessment.question.control_worrying')}
            type="gad"
            onSetValue={onSetValue}
            assessmentValues={assessmentValues}
            radioOptions={radioOptions}
            outerId="over_last_2_weeks_3"
          />
          <DotRadio
            questionid="worrying_too_much"
            range="4"
            width=""
            questionTitle={t('assessment.question.worrying_too_much')}
            type="gad"
            onSetValue={onSetValue}
            assessmentValues={assessmentValues}
            radioOptions={radioOptions}
            outerId="over_last_2_weeks_3"
          />
          <DotRadio
            questionid="trouble_relaxing"
            range="4"
            width=""
            questionTitle={t('assessment.question.trouble_relaxing')}
            type="gad"
            onSetValue={onSetValue}
            assessmentValues={assessmentValues}
            radioOptions={radioOptions}
            outerId="over_last_2_weeks_3"
          />
          <DotRadio
            questionid="restless"
            range="4"
            width=""
            questionTitle={t('assessment.question.restless')}
            type="gad"
            onSetValue={onSetValue}
            assessmentValues={assessmentValues}
            outerId="over_last_2_weeks_3"
          />
          <DotRadio
            questionid="annoyed"
            range="4"
            width=""
            questionTitle={t('assessment.question.annoyed')}
            type="gad"
            onSetValue={onSetValue}
            assessmentValues={assessmentValues}
            radioOptions={radioOptions}
            outerId="over_last_2_weeks_3"
          />
          <DotRadio
            questionid="afraid"
            range="4"
            width=""
            questionTitle={t('assessment.question.afraid')}
            type="gad"
            onSetValue={onSetValue}
            assessmentValues={assessmentValues}
            radioOptions={radioOptions}
            outerId="over_last_2_weeks_3"
          />
        </div>
      </fieldset>
    </div>
  );
}
